import React from 'react'
import { Link, useLocation } from 'react-router-dom'
import { createLocalizedPath } from '../../../utils/localizationHelpers'
import paths, { pureUrls } from '../../../paths'
import './paginationLink.sass'

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationIndexLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, ...rest } = props
    const location = useLocation()
    return (
        <Link
            to={{ pathname: location.pathname, search: `?p=${eventKey}` }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars,@typescript-eslint/no-unused-vars
export const PaginationProfilesLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, ...rest } = props
    return (
        <Link
            to={{ pathname: createLocalizedPath(paths.profiles.path), search: `?p=${eventKey}` }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationSearchLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, ...rest } = props
    const location = useLocation()
    const currenTag = location.search
        ? new URLSearchParams(location.search).get('query')
        : location.pathname.split('/').reverse()[0]
    return (
        <Link
            to={{
                pathname: location.pathname,
                search: currenTag ? `?query=${currenTag}&p=${eventKey}` : `?p=${eventKey}`
            }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationSearchContributionsLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, currentTag, ...rest } = props
    const location = useLocation()
    const currenTag = location.search
        ? new URLSearchParams(location.search).get('query')
        : location.pathname.split('/').reverse()[0]
    return (
        <Link
            to={{
                pathname: location.pathname,
                search: currenTag ? `?query=${currenTag}&p=${eventKey}` : `?p=${eventKey}`
            }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationTagsLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, ...rest } = props
    return (
        <Link
            to={{ pathname: createLocalizedPath(paths.tags.path), search: `?&p=${eventKey}` }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationRechercheLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, currentTag, ...rest } = props
    return (
        <Link
            to={{
                pathname: createLocalizedPath(paths.recherche.path),
                search: `?p=${eventKey}`
            }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationUserForumPostsLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, currentTag, ...rest } = props
    const location = useLocation()
    return (
        <Link
            to={{
                pathname: location.pathname,
                search: `?p=${eventKey}`
            }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})

// eslint-disable-next-line @typescript-eslint/no-explicit-any,react/display-name,@typescript-eslint/no-unused-vars
export const PaginationArchiveLink = React.forwardRef((props: any, ref) => {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { href, active, eventKey, as, currentTag, ...rest } = props
    const location = useLocation()
    return (
        <Link
            to={{ pathname: location.pathname, search: `?p=${eventKey}` }}
            className={active ? 'rs-pagination-btn rs-pagination-btn-active' : 'rs-pagination-btn'}
        >
            {eventKey}
        </Link>
    )
})
